<template>
    <div>
        <modal-exportar-extrato-bancario :listaGrupos="listaGrupos" :loadGrupos="loadGrupos" />
        <modal-info-extrato />

        <container-card id="filtroExtratoBancario" icon="fa-filter" title="Selecione as opções de pesquisa.">
            <b-card><!-- FILTROS -->
                <span class="btn-info-ic el-icon-info"  @click="infoModal"></span>
                <el-form class="geral-form" ref="formFiltroExtratoBancario" :model="modelFiltro" :rules="rules" size="small" label-position="top">
                    <el-row :gutter="20">
                        
                        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item label="Grupo" prop="cliente" v-loading="loadGrupos" required>
                                <el-select class="w-100" size="small" v-model="modelFiltro.cliente" filterable clearable :placeholder="`Selecione um grupo`">
                                    <el-option
                                    v-for="item in listaGrupos"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item label="Empresas" prop="empresas" v-loading="loadEmpresas">
                                <el-select class="w-100" size="small" v-model="modelFiltro.empresas" filterable multiple collapse-tags clearable :disabled="habilitaEmpresaConta" :placeholder="`Selecione uma empresa`">
                                    <el-option
                                    v-for="item in listaEmpresas"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item label="Conta" prop="conta" v-loading="loadConta" required>
                                <el-select class="w-100" size="small" v-model="modelFiltro.conta" filterable clearable :disabled="habilitaEmpresaConta" :placeholder="`Selecione uma conta`">
                                    <el-option
                                    v-for="item in listaContas"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                            <el-form-item label="Data início/Fim" prop="inicioFim" required>
                                <el-date-picker
                                    v-model="modelFiltro.inicioFim"
                                    type="daterange"
                                    range-separator="|"
                                    start-placeholder="De"
                                    end-placeholder="Até"
                                    align="right"
                                    format="dd/MM/yyyy"
                                    size="small"
                                    class="w-100">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                
                <div slot="footer">
                    <div class="float-left btn-pesquisar" >
                        <el-button size="small" @click.prevent="pesquisarExtrato" type="primary" icon="el-icon-search">Pesquisar</el-button> 
                        <el-button size="small" @click.prevent="limparExtrato" icon="el-icon-brush">Limpar</el-button> 
                    </div>
                    <el-button class="float-right" size="small" type="success" icon="el-icon-download" @click="exportarExtrato">Filtros para Exportar</el-button>
                </div>
            </b-card>
        </container-card>

        <container-card id="TableExtratoBancario" icon="fa-money-check-alt" title="Extrato bancário">
            <b-card><!-- FILTROS -->
                <el-table
                    class="f360-ntable"
                    v-loading="tableOptions.load"
                    :data="tableOptions.data"
                    style="width: 100%"
                    stripe
                    border
                    size="mini">

                    <el-table-column
                        prop="data"
                        label="Data"
                        align="center"
                        width="100">
                        <template slot-scope="scope" v-if="scope.row">
                            {{ moment(scope.row.data).format('DD-MM-YYYY') }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="historico"
                        label="Histórico"
                        align="left">
                    </el-table-column>

                    <el-table-column
                        prop="numeroDocumento"
                        label="N° Documento"
                        width="100"
                        align="left">
                    </el-table-column>

                    <el-table-column
                        prop="entrada"
                        label="Entrada"
                        width="150"
                        align="right">
                    </el-table-column>

                    <el-table-column
                        prop="saida"
                        label="Saída"
                        width="150"
                        align="right">
                    </el-table-column>

                    <el-table-column
                        prop="saldo"
                        label="Saldo"
                        width="150"
                        align="right">
                    </el-table-column>

                    <el-table-column
                        prop="extratoConciliado"
                        label="ExtratoConciliado"
                        width="150"
                        align="center">
                        <template slot-scope="scope" v-if="scope.row">
                            <el-tooltip v-if="scope.row.extratoConciliado === true" class="item" effect="dark" content="Status: Conciliado" placement="top-start">
                                <i class="fas fa-circle text-success"></i>
                            </el-tooltip>
                            <el-tooltip v-if="scope.row.extratoConciliado === false" class="item" effect="dark" content="Status: Não Conciliado" placement="top-start">
                                <i class="fas fa-circle text-warning"></i>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    
                    <!-- <el-table-column
                        prop="empresas"
                        label="Empresas"
                        align="center"
                        width="170">
                        <template slot-scope="scope" v-if="scope.row">
                            <el-button round icon="el-icon-view" @click="mostrarListaEmpresasModal(scope.row)" size="mini">Ver empresas</el-button>
                        </template>
                    </el-table-column> -->
                </el-table><br>
            </b-card>
        </container-card>
    </div>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import ModalExportarExtratoBancario from './ModalExportarExtratoBancario.vue';
import ModalInfoExtrato from './ModalInfoExtrato.vue';

export default {
    name: 'extrato-bancario',
    components: {
    ContainerCard,
    ModalExportarExtratoBancario,
    ModalInfoExtrato
},
    data() {
        return {
            loadGrupos: false,
            loadEmpresas: false,
            loadConta: false,
            listaGrupos: [],
            listaEmpresas: [],
            listaContas: [],
            modelFiltro: {
                cliente: '',
                empresas: [],
                conta: '',
                inicioFim: []
            },
            tableOptions: {
                load: false,
                data: []
            },
            mostrarModalExportar: false,
            rules: {
                cliente: [
                    { required: true, message: 'Por favor, escolha um grupo', trigger: ['change','blur'] }
                ],
                conta: [
                    { required: true, message: 'Por favor, escolha uma conta', trigger: ['change','blur'] }
                ],
                inicioFim: [
                    { type: 'array', required: true, message: 'Por favor, escolha um range de datas', trigger: 'change' }
                ]
			},
        }
    },
    methods: {
        pesquisarExtrato() {
            const ctx = this

            ctx.$refs['formFiltroExtratoBancario'].validate((valid) => {
                if (!valid) {
					ctx.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos obrigatórios`,
						position:'top-left'
					});
					return
				}

                ctx.PesquisaExtrato()
            });
        },
        async PesquisaExtrato() {
            this.tableOptions.load = true;

            const params = {
                ClienteId: this.modelFiltro.cliente,
                ContaId: this.modelFiltro.conta,
                Inicio: this.modelFiltro.inicioFim[0],
                Fim: this.modelFiltro.inicioFim[1],
            }

            try {
                const response = await this.axios.get(this.$urls.LISTAR_EXTRATO, {
                    params: params
                });

                this.tableOptions.data = response.data;

            } catch (error) {
                console.error('Erro ao pesquisar extrato:', error);
            } finally {
                this.tableOptions.load = false;
            }
        },
        async getGrupos() { // clientes
            this.loadGrupos = true

            try {
                const response = await this.axios.get(this.$urls.GRUPOS)
                
                if(response.status !== 200) {
                    throw new Error('Erro ao carregar lista de Clientes')
                }

                this.listaGrupos = response.data
            } catch(err) {
                console.error(err)
            } finally {
                this.loadGrupos = false
            }
        },
        async getContas(idCliente, idEmpresas) { // clientes
            this.loadConta = true

            const idsEmp = idEmpresas ? `&empresasIds=${idEmpresas}` : ''

            try {
                const response = await this.axios.get(`${this.$urls.CONTAS}?clienteId=${idCliente}${idsEmp}`)
                
                if(response.status !== 200) {
                    throw new Error('Erro ao carregar lista de Contas')
                }

                this.listaContas = response.data
            } catch(err) {
                console.error(err)
            } finally {
                this.loadConta = false
            }
        },
        async getEmpresas(idCliente) { // clientes
            this.loadEmpresas = true

            try {
                const response = await this.axios.get(`${this.$urls.EMPRESAS_POR_CLIENTE}?clienteId=${idCliente}`)
                
                if(response.status !== 200) {
                    throw new Error('Erro ao carregar lista de Empresas')
                }

                this.listaEmpresas = response.data
            } catch(err) {
                console.error(err)
            } finally {
                this.loadEmpresas = false
            }
        },
        limparExtrato() {
            this.modelFiltro.conta = ''
            this.modelFiltro.cliente = ''
            this.modelFiltro.empresas = []
            this.modelFiltro.inicioFim = []

            this.$refs['formFiltroExtratoBancario'].clearValidate();
        },
        exportarExtrato() {
            this.$bvModal.show('modal-exportar-extrato')
        },
        infoModal() {
            this.$bvModal.show('modal-info-extrato')
        }
    },
    computed: {
        habilitaEmpresaConta() {
            return !this.modelFiltro.cliente
        }
    },
    watch: {
        'modelFiltro.cliente'(id) {
            this.modelFiltro.conta = ""
            this.modelFiltro.empresas = []
            this.$refs['formFiltroExtratoBancario'].clearValidate();
            if(id) {
                this.getEmpresas(id)
                this.getContas(id)
            }
        },
        'modelFiltro.empresas'(id) {
            this.modelFiltro.conta = ""
            this.$refs['formFiltroExtratoBancario'].clearValidate();
            if(id.length) {
                this.getContas(this.modelFiltro.cliente, id.join(','))
            }
        }
    },
    mounted() {
        this.getGrupos()
        //this.getContas()
    }
}
</script>
<style lang="scss">
.btn-info-ic {
    position: absolute;
    top: -27px;
    left: 274px;
    cursor: pointer;
}
</style>
